import React from 'react'
import UserGreenIcon from '../../../Common/svg/usergreenicon'
import PhoneIcon from '../../../Common/svg/phoneicon'
import LocationSvg from '../../../Common/svg/locationGray'
import StoreIconSide from '../../../Common/svg/storeiconside'

const StoreInfo = ({store}) => {
  return (
   <div className="col-md-4">
          <div className="card rounded-4 shadow-sm">
            <div className="card-body">
              <div className="d-flex align-items-center gap-2  mb-3 ">
              <div className='text-green'>  <StoreIconSide />  </div> 
                <h5 className="text-smoke font16 font700"> معلومات المتجر</h5>
              </div>
              <ul className="d-flex flex-column gap-2   mt-2">
                <div>
                  <h6 className="text-gray">اسم المتجر</h6>
                  <h6 className='text-smoke'> {store?.name} </h6>
                </div>
                <li className="d-flex align-items-center gap-1 ">
                  <PhoneIcon /> <span className='text-smoke'>{store?.phone}</span>
                </li>
                  <li className="d-flex align-items-center gap-1 ">
                  <LocationSvg /> <span className='text-smoke'> {store?.address} </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
  )
}

export default StoreInfo